// extracted by mini-css-extract-plugin
module.exports = {"Select":"styles_Select__8MlCH","icon":"styles_icon__9RdJO","select":"styles_select__cjCby"};